import React from "react";
import { useSelector, useDispatch } from "react-redux";
import ItemDateCard from "~business/Cards/ItemDateCard";
import DetalleCard from "~business/Cards/DetalleCard";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { DateRange } from "~api/types";
import {
  getEmisiones,
  getEmisionesDeComisiones,
  setFechaDesde,
  setFechaHasta,
  GetEmisionesState,
} from "./actions";
import { FechaField } from "../types";

const useReduxSelector = () =>
  useSelector<any, GetEmisionesState>((state) => ({
    ...state.getEmisionesReducer,
  }));

const EmisionesCard: React.FC = () => {
  const dispatch = useDispatch();
  const {
    fechaDesdeSelected,
    fechaHastaSelected,
    buttonEnabled,
    buttonText,
    buttonComisionesText,
  } = useReduxSelector();

  const handleChangeFechaDesde = (fechaDesde: FechaField) => {
    dispatch(setFechaDesde(fechaDesde));
  };
  const handleChangeFechaHasta = (fechaHasta: FechaField) => {
    dispatch(setFechaHasta(fechaHasta));
  };
  // ItemDateCard deja en value lo que le llega (Date, texto o null); el API
  // los formatea con date-fns como hasta ahora.
  const getData = (): DateRange => ({
    fechaDesde: fechaDesdeSelected.value as Date,
    fechaHasta: fechaHastaSelected.value as Date,
  });
  const handleGetEmisiones = () => {
    dispatch(getEmisiones(getData()) as any);
  };
  const handleGetEmisionesDeComisiones = () => {
    dispatch(getEmisionesDeComisiones(getData()) as any);
  };

  return (
    <>
      <DetalleCard title={"Emisiones"}>
        <ItemDateCard
          label="Desde"
          value={fechaDesdeSelected.value}
          onChange={handleChangeFechaDesde}
        />
        <ItemDateCard
          label="Hasta"
          value={fechaHastaSelected.value}
          onChange={handleChangeFechaHasta}
        />
        <Box mt={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm="auto">
              <Button
                variant="contained"
                color="primary"
                onClick={handleGetEmisiones}
                disabled={!buttonEnabled}
              >
                {buttonText}
              </Button>
            </Grid>
            <Grid item xs={12} sm="auto">
              <Button
                variant="contained"
                color="primary"
                onClick={handleGetEmisionesDeComisiones}
                disabled={!buttonEnabled}
              >
                {buttonComisionesText}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </DetalleCard>
    </>
  );
};

export default EmisionesCard;
